import { useMessages, useTranslations } from 'next-intl';

export const currentYear = new Date().getFullYear();

export const academicYearList = Array.from(
  { length: 5 },
  (value, index) => new Date().getFullYear() + index,
);

export function getMonthOptions(
  messages: ReturnType<typeof useMessages>,
): { text: string; value: string }[] {
  return Object.values((messages as Record<string, any>).DatePicker.monthsList).map(
    (messageValue, index) => ({
      text: messageValue as string,
      value: index.toString(),
    }),
  );
}

export function getSubjectList(message: typeof useTranslations): { text: string; value: string }[] {
  const translate = message(`Contact`);

  return [
    {
      text: translate(`subjectList.accounting`),
      value: `Economics, Accounting and Finance`,
    },
    {
      text: translate(`subjectList.socialSciences`),
      value: `Social Sciences and Humanities`,
    },
    {
      text: translate(`subjectList.business`),
      value: `Business and Management`,
    },
    {
      text: translate(`subjectList.arts`),
      value: `Arts`,
    },
    {
      text: translate(`subjectList.computing`),
      value: `Computing and Information Systems`,
    },
    {
      text: translate(`subjectList.sciences`),
      value: `Science`,
    },
    {
      text: translate(`subjectList.engineering`),
      value: `Engineering`,
    },
    {
      text: translate(`subjectList.other`),
      value: ``,
    },
  ];
}

export function getINTOCountryList(
  message: typeof useTranslations,
): { text: string; value: string }[] {
  const translate = message(`Contact`);

  return [
    {
      text: translate(`countriesList.uk`),
      value: `UK`,
    },
    {
      text: translate(`countriesList.us`),
      value: `USA`,
    },
    {
      text: translate(`countriesList.australia`),
      value: `Australia`,
    },
    {
      text: translate(`countriesList.undecided`),
      value: `Undecided`,
    },
  ];
}
